import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { WebAdmin } from '../models/WebAdmin'

type SaveWebAdminPayload = {
  webAdmin: Record<string, unknown>
}

export const saveWebAdmin = createAsyncThunk<WebAdmin, SaveWebAdminPayload, ThunkApiContext>('webAdmins/saveWebAdmin', async ({ webAdmin }: SaveWebAdminPayload, { dispatch }) => {
  const response = await OLMSApiService.post<WebAdmin>('webadmin/save', webAdmin)

  if (!response) {
    dispatch(setToast({
      open: true,
      severity: 'error',
      title: 'Save web admin',
      content: 'Failed to save web admin',
    }))
    throw new Error('Failed to save webAdmin')
  }

  dispatch(setToast({
    open: true,
    severity: 'success',
    title: 'Save web admin',
    content: `Successfully saved web admin ${response.name} with login ${response.login}`,
  }))

  return response
})